import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  getColor,
  Icons,
  InputArea,
  InputField,
  Radio,
  Tooltip,
  Typography,
} from "fds";
import "./index.scss";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import utilsDocs from "../../shared/utils/docs";
import { DocInfo, UploadFile } from "../../types/files";
import { t } from "i18next";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import WorkgroupAvatar from "../WorkgroupAvatar";
interface ExistWorkgroupPageProps {
  files?: UploadFile[];
  changeFiles: (files: UploadFile[]) => void;
  classes?: string;
  uid?: string;
  copyFileResp?: {
    files: DocInfo[];
    workgroupId?: string;
    message?: string;
  };
  targetType?: "DROPBOX" | "client";
  changeCopyFileResp?: (req: {
    files: DocInfo[];
    workgroupId?: string;
    workgroupName?: string;
    message?: string;
  }) => void;
  changeIsNextButtonDisabled: (v: boolean) => void;
}
const ExistWorkgroupPage: React.FC<ExistWorkgroupPageProps> = ({
  files,
  copyFileResp,
  targetType,
  uid,
  changeFiles,
  changeIsNextButtonDisabled,
  changeCopyFileResp,
  classes,
}) => {
  /** Hook 정리 */
  const { workgroupState, getWorkgroupSimpleList } = useWorkgroupStore();
  const { removeFileFromUid } = useDocumentStore();
  /** State 정리 */
  const [workgroupList, changeWorkgroupList] = useState<Workgroup[]>([]); // 표시되는 validate한 워크그룹 리스트
  const [targetWorkgroup, changeTargetWorkgorup] = useState(""); // 선택된 워크그룹 Id
  const [keyword, changeKeyword] = useState(""); // 검색어

  /** useEffect 정리 */
  useEffect(() => {
    const currentWorkgroupId = window.location.pathname.split("/")[2] ?? "";
    changeWorkgroupList(
      workgroupState.simpleWorkgroupList.filter(
        (item: Workgroup) =>
          item.isValidate !== 0 &&
          (item.workgroupId !== currentWorkgroupId || targetType === "DROPBOX")
      )
    );
  }, [workgroupState.simpleWorkgroupList]);
  useEffect(() => {
    changeIsNextButtonDisabled(!targetWorkgroup);
  }, [targetWorkgroup]);
  useEffect(() => {
    getWorkgroupSimpleList({
      isDetail: "Y",
      managerId: "",
      orderBy: "workgroupName",
      orderByType: "ASC",
      pageRange: 1,
      posPage: 1,
      rowRange: 0,
      searchDate: {
        start: 0,
        end: 0,
      },
      status: 1,
      workgroupName: "",
    });
  }, []);

  /** 함수 정리 */
  /** UI: 하단 파일 리스트 */
  const renderFileList = (files: any) => {
    return (
      <Box classes="upload-fileList">
        {files.map((file: any) => (
          <Box classes="upload-file">
            <Box>
              {utilsDocs.renderDocIcon(file.fileName ?? file.contentName, 20)}
            </Box>
            <Tooltip
              message={file.fileName ?? file.contentName}
              // maxWidth={"calc(100% - 36px)"}
              maxWidth={400}
            >
              <Typography type="body4_rg" ellipsis classes="mg ml-4">
                {file.fileName ?? file.contentName}
              </Typography>
            </Tooltip>
            {files.length > 1 && (
              <Box
                alignItems="center"
                classes="mg ml-4 cursor pointer"
                onClick={() => {
                  if (file.syncId) {
                    uid && removeFileFromUid(uid, file.uuid, file.fileId);
                    changeFiles(
                      files.filter((item: any) => item.syncId !== file.syncId)
                    );
                    changeCopyFileResp &&
                      changeCopyFileResp({
                        ...copyFileResp,
                        files:
                          copyFileResp?.files?.filter(
                            (item) => item?.syncId !== file?.syncId
                          ) ?? [],
                      });
                  } else {
                    uid && removeFileFromUid(uid, file.uuid, file.fileId);
                    changeFiles(
                      files.filter((item: any) => item.fileId !== file.fileId)
                    );
                  }
                }}
              >
                <Icons variant="line" label="closeLarge" size={12} />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    );
  };
  return (
    <Box direction={"column"} classes="existWorkgroup">
      <InputField
        placeholder={t("workgroup.workgroupPlaceholder")}
        size="md"
        leadingIcon={<Icons variant="line" label="search" />}
        value={keyword}
        onChange={(e) => changeKeyword(e.target.value)}
      />
      <Box classes="mg mt-16">
        <Typography type="subtitle2">
          {t("workgroup.existWorkgroup")}
        </Typography>
        <Typography
          type="subtitle2"
          exactColor={getColor("COLOR_TEXT_BRAND")}
          classes="mg ml-4"
        >
          {workgroupList.filter((item) => item.workgroupName.includes(keyword))
            .length ?? 0}
        </Typography>
      </Box>
      <Box classes="existWorkgroup-members">
        {workgroupList
          .filter((item) => item.workgroupName.includes(keyword))
          .map((item) => (
            <Box classes="existWorkgroup-member">
              <WorkgroupAvatar item={item} />

              <Tooltip
                message={item.workgroupName}
                maxWidth={"calc(100% - 75px)"}
              >
                <Typography classes="mg ml-8" ellipsis type="body2_rg">
                  {item.workgroupName}
                </Typography>
              </Tooltip>
              <Radio
                style={{ marginInlineStart: "auto" }}
                check={targetWorkgroup === item.workgroupId}
                onClick={() => {
                  changeTargetWorkgorup(item.workgroupId);
                  changeCopyFileResp &&
                    copyFileResp &&
                    changeCopyFileResp({
                      ...copyFileResp,
                      workgroupName: item.workgroupName,
                      workgroupId: item.workgroupId,
                    });
                }}
              />
            </Box>
          ))}
      </Box>
      {renderFileList(files ?? copyFileResp?.files)}
      <Box direction="column">
        <Typography type="subtitle2" classes="mg mt-8 mb-6">
          {t("common.message")}
        </Typography>
        <InputArea
          placeholder={t("common.messagePlaceholder")}
          size="sm"
          onChange={(e) =>
            copyFileResp &&
            changeCopyFileResp &&
            changeCopyFileResp({ ...copyFileResp, message: e.target.value })
          }
          rows={3}
          maxLength={256}
        />
      </Box>
    </Box>
  );
};
export default ExistWorkgroupPage;
